import firebase from "firebase";

export const database = firebase.database();
export const peopleRef = database.ref("people");
export const vehiclesRef = database.ref("vehicles");
export const activePersonsRef = database.ref("activePersons");
export const inactivePersonsRef = database.ref("inactivePersons");
export const groupsRef = database.ref("groups");
export const membershipsRef = database.ref("memberships");
export const slackMembershipsRef = database.ref("slackMemberships");
export const technologyRef = database.ref("technology");
export const skillsMapRef = database.ref("skillsMap");
export const togglProjectsRef = database.ref("togglProjects");
export const projectsRef = database.ref("projects");
export const projectsLeadsRef = database.ref("projectsLeads");
export const projectManagementOverviewViewRef = database.ref("projectManagementOverviewView");
export const projectManagementDetailsViewRef = database.ref("projectManagementDetailsView");
export const projectsUpdatesRef = database.ref("projectsUpdates");
export const birthdaysThisMonthRef = database.ref("birthdaysThisMonth");
export const anniversariesThisMonthRef = database.ref("anniversariesThisMonth");
export const administratorsRef = database.ref("administrators");
export const usersRef = database.ref("users");

export const skillsRatingRef = database.ref("skillsRating");
export const skillsRatingByPersonRef = database.ref("skillsRating/byPerson");



// WEBPACK FOOTER //
// ./src/vue-service-database.js